import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'

// Axios Mock Adapter
import '@/@fake-db/db'

import 'devextreme/dist/css/dx.light.css';


import * as Sentry from "@sentry/vue";

import { registerLicense } from '@syncfusion/ej2-base';

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration({
      // pass router in, if applicable
      router,
    }),
    Sentry.feedbackIntegration({
      showBranding:false,
      triggerLabel: "Send feedback",
      formTitle: "Send feedback",
      messagePlaceholder: "Send feedback",
      submitButtonLabel: "Send"
    })
  ],
  tracePropagationTargets: ["localhost", "dev.costctrl.com", "staging.costctrl.com", /^\//],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  environment: process.env.VUE_APP_SENTRY_ENV,
});




// Registering Syncfusion license key
//registerLicense('@32392e302e303b32393bWvcjTb4NxO21OH9oBzSCyzF1f1yewzIwu6qqbTkDC10='); UNLOCK KEY
registerLicense(process.env.VUE_APP_SYNCFUSION_KEY) // LICENSE KEY

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
